import React from "react";
import { Newspaper, Cake, Skull, Music, Trophy, Swords, Clapperboard, Sparkles } from "lucide-react";

const JUMPS = [
  { id: "today-in-history", label: "Today", icon: Newspaper },
  { id: "births", label: "Births", icon: Cake },
  { id: "deaths", label: "Deaths", icon: Skull },
  { id: "number-ones", label: "No.1s", icon: Music },
  { id: "sports", label: "Sport", icon: Trophy },
  { id: "battles", label: "Battles", icon: Swords },
  { id: "movies", label: "Movies", icon: Clapperboard },
  { id: "horoscope", label: "Stars", icon: Sparkles },
];

/** Mobile-only sticky strip of section shortcuts under the header (desktop has the nav bar + wide layout). */
export const SectionJumps = ({ onJump }) => (
  <nav data-testid="section-jumps" aria-label="Jump to section" className="md:hidden sticky top-[76px] z-40 px-4 py-2 bg-paper/95 backdrop-blur border-b border-[#e5e7eb] overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    <div className="flex gap-2 w-max">
      {JUMPS.map((j) => (
        <button key={j.id} type="button" data-testid={`jump-${j.id}`} onClick={() => onJump(j.id)} className="inline-flex items-center gap-1.5 shrink-0 px-3 h-8 rounded-full border border-ink/15 bg-white text-[12px] font-semibold text-ink active:bg-gold/20">
          <j.icon className="w-3.5 h-3.5 text-gold" /> {j.label}
        </button>
      ))}
    </div>
  </nav>
);
